export default __webpack_public_path__ + "static/media/json_data.495a1462.PNG";